import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Head extends Vue { }



// WEBPACK FOOTER //
// ./src/app/components/Head/Head.ts